import { stateGo } from 'redux-ui-router';
import { selectHasMealPlanRecipe } from 'logic/mealPlan';
import { selectHasWeeklySubscription } from 'logic/member';

export const ProgramMealPlan = {
  template: `
    <div class="program-meal-plan">
      <nav-page>
        <nav-left>
          <button-back
            on-click="$ctrl.stateGo('program.week', { weekNumber: $ctrl.weekNumber })">
            Week {{ $ctrl.weekNumber }}
          </button-back>
        </nav-left>
      </nav-page>
      <div class="program-meal-plan-container">
        <header class="container text-center pt-4 pb-3"
          ng-hide="$ctrl.name === 'program.week.mealPlan.edit'">
          <h2>Week {{ $ctrl.weekNumber }} Meal Plan</h2>
          <meal-plan-nav
            name="$ctrl.name"
            meal-plan-name="program.week.mealPlan"
            shopping-list-name="program.week.mealPlan.shoppingList"
            is-disabled="!$ctrl.hasMealPlanRecipe"
            on-click="$ctrl.stateGo(name)">
          </meal-plan-nav>
        </header>
        <ui-view>
          <div ng-if="$ctrl.hasWeekly">
            <meal-plan></meal-plan>
          </div>
          <div ng-if="!$ctrl.hasWeekly">
            <meal-plan-basic></meal-plan-basic>
          </div>
        </ui-view>
      </div>
    </div>`,

  controller($ngRedux, $anchorScroll) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
        $anchorScroll();
      },

      $onDestroy() {
        this.disconnect();
      },

      mapState({ mealPlan, member, router }) {
        const { mealPlanId } = router.currentParams;

        return {
          hasWeekly: selectHasWeeklySubscription(member),
          weekNumber: router.currentParams.weekNumber,
          name: router.currentState.name,
          hasMealPlanRecipe: selectHasMealPlanRecipe(mealPlan, mealPlanId),
        };
      },

      mapDispatch() {
        return {
          stateGo,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Program/MealPlan.js